import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebaseConfig';

import { clientOrigin } from './siteEnvironment';

export function openOrganizationDashboard(organizationId: string, serviceRequestId?: string, workflowId: 'ep_advance_site_survey' | 'project_planner' | 'trm_brief' | 's01_fsat' | 's02_facility_plan' | 's03_staff_protection_plan' | 's04_event_security_plan' | 's05_country_intelligence' | 's06_threat_group_briefing' | 's07_daily_intelligence' | 's12_pre_movement_intelligence' | 's13_crisis_management' | 's14_business_resiliency' | 's15_hsse_compliance' | 's16_emergency_preparedness' = 'ep_advance_site_survey', beforeAccess?: Promise<unknown>, accessMode: 'management' | 'client' = 'management', reportDraftId?: string): Promise<void> {
    const nonce = crypto.randomUUID();
    const ready = beforeAccess?.then(() => null, error => ({ error }));
    const popup = window.open(`${clientOrigin}/${accessMode === 'client' ? 'client-access' : 'admin-access'}#${nonce}`, '_blank');
    if (!popup)
        return Promise.reject(new Error('Allow pop-ups to open the client dashboard.'));
    return new Promise((resolve, reject) => {
        let started = false;
        let ended = false;
        const cleanup = () => {
            ended = true;
            clearTimeout(timeout);
            clearInterval(closed);
            window.removeEventListener('message', receive);
        };
        const fail = (message: string) => {
            cleanup();
            reject(new Error(message));
        };
        const receive = async (event: MessageEvent) => {
            if (event.origin !== clientOrigin || event.source !== popup || event.data?.nonce !== nonce)
                return;
            if (event.data?.type === 'organization-access-complete') {
                cleanup();
                resolve();
            } else if (event.data?.type === 'organization-access-error')
                fail('Client access failed. Open the dashboard again.');
            else if (event.data?.type === 'organization-access-ready' && !started) {
                started = true;
                try {
                    const blocked = await ready;
                    if (ended)
                        return;
                    if (blocked)
                        throw blocked.error;
                    const result = await httpsCallable<{ organizationId: string; accessMode?: 'client'; reportDraftId?: string }, { ticket: string }>(functions, 'createOrganizationAccess')({ organizationId,
                        ...(reportDraftId ? { reportDraftId } : {}),
                        ...(accessMode === 'client' ? { accessMode } : {}) });
                    if (ended)
                        return;
                    popup.postMessage({ type: 'organization-access-ticket', nonce, ticket: result.data.ticket,
                        ...(serviceRequestId ? { serviceRequestId, workflowId } : {}) }, clientOrigin);
                } catch (error) {
                    if (ended)
                        return;
                    popup.postMessage({ type: 'organization-access-error', nonce }, clientOrigin);
                    cleanup();
                    reject(error);
                }
            }
        };
        const timeout = window.setTimeout(() => fail('Dashboard access timed out. Open it again.'), 90_000);
        const closed = window.setInterval(() => {
            if (popup.closed)
                fail('The client dashboard tab was closed.');
        }, 500);
        window.addEventListener('message', receive);
    });
}

export const openClientDashboard = (organizationId: string) => openOrganizationDashboard(organizationId, undefined, undefined, undefined, 'client');
export const openConsultantReportWorkspace = (organizationId: string, reportDraftId: string, beforeAccess?: Promise<unknown>) =>
    openOrganizationDashboard(organizationId, undefined, undefined, beforeAccess, 'management', reportDraftId);
